"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainHeaderWrapperClass = exports.MainHeaderWrapper = void 0;
var MainHeaderWrapper = 'main-header-wrapper';
exports.MainHeaderWrapper = MainHeaderWrapper;
var MainHeaderWrapperClass = ".".concat(MainHeaderWrapper);
exports.MainHeaderWrapperClass = MainHeaderWrapperClass;